import React, { createContext, useState, useContext } from 'react';
import { login as apiLogin } from '../services/apiServices';

const AuthContext = createContext();

export const useAuth = () => {
  return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const isAuthenticated = !!user;

  const login = async (username, password, totpCode, setupSecret) => {
    try {
      const response = await apiLogin({ username, password, totpCode, setupSecret });

      if (response.require2FASetup) {
        return { require2FASetup: true, secret: response.secret, otpauthUrl: response.otpauthUrl };
      }

      if (response.require2FA) {
        return { require2FA: true };
      }

      if (response.success) {
        sessionStorage.setItem('user', JSON.stringify(response.user));
        setUser(response.user);
        return { success: true };
      } else {
        throw new Error(response.message || 'Falha na autenticação');
      }
    } catch (error) {
      throw error;
    }
  };

  const logout = () => {
    sessionStorage.removeItem('user');
    setUser(null);
  };

  const value = { user, isAuthenticated, login, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};